export default {
  dicCateId: '类型名称',
  value: '字典值',
  dictItem: '字典项',
  dictType: '字典类型',
}
